import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
import * as Sts_credentials_bs$SolvuuApi0 from "./sts_credentials_bs.bs.js";
var write_location = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Atdgen_codec_runtime.Encode.string, "bucket", t.bucket),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Atdgen_codec_runtime.Encode.string, "key", t.key),
  /* [] */
  0]]);
});
var read_location = Atdgen_codec_runtime.Decode.make(function (json) {
  return {
    bucket: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("bucket", Atdgen_codec_runtime.Decode.string, param);
    }, json),
    key: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("key", Atdgen_codec_runtime.Decode.string, param);
    }, json)
  };
});
var write_credentials = Atdgen_codec_runtime.Encode.make(function (x) {
  return Atdgen_codec_runtime.Encode.constr1("Sts", Sts_credentials_bs$SolvuuApi0.write_t, x[1]);
});
var read_credentials = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Sts",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Sts */
      [4153490, x]
    );
  }, Sts_credentials_bs$SolvuuApi0.read_t, param);
}]],
/* [] */
0]);
var write_instructions = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write_location, "location", t.location),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write_credentials, "credentials", t.credentials),
  /* [] */
  0]]);
});
var read_instructions = Atdgen_codec_runtime.Decode.make(function (json) {
  return {
    location: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("location", read_location, param);
    }, json),
    credentials: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("credentials", read_credentials, param);
    }, json)
  };
});
var read_sts_credentials = Sts_credentials_bs$SolvuuApi0.read_t;
var write_sts_credentials = Sts_credentials_bs$SolvuuApi0.write_t;
export { read_sts_credentials, write_sts_credentials, read_location, write_location, read_credentials, write_credentials, read_instructions, write_instructions };
/* write_location Not a pure module */